"use strict";

import {onFind} from "@elements/init-modules-in-scope";
import {findAll, findIn, findAllIn } from "@elements/dom-utils";

export function init () {
    let areas = findAll('.js-filter-counter-area', document);

    areas.map(function (counterArea){
        let filterArea = counterArea;
        let filterCounter = findIn('.js-filter-counter__counter', filterArea);
        let filterResets = findAll('.js-filter-counter__reset', filterArea);
        let inputs = findAllIn('.form-check-input', filterArea);

        updateCounter(inputs, filterCounter);

        filterArea.addEventListener('change', function () {
            updateCounter(inputs, filterCounter);
        });

        filterResets.map(function (filterReset){
            filterReset.addEventListener('click',  function(){
                filterCounter.innerHTML = 0;
            });
        });
    });

}

function updateCounter(inputs, filterCounter){
    let counter = 0;
    inputs.map(function (input){
        if (input.checked) {
            counter++;
        }
    });
    filterCounter.innerHTML = counter;
}